import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PageShell } from "@/components/site/PageShell";
import { api } from "@/lib/api";

export default function Legal() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  useEffect(() => { api.get(`/legal/${slug}`).then((r) => setPage(r.data.page)).catch(() => setPage(false)); }, [slug]);
  return (
    <PageShell testId="legal-page" overline="Legal" title={page ? page.title : page === false ? "Page not found" : ""}>
      {page && (
        <article className="max-w-3xl space-y-6">
          <p className="text-sm rounded-lg bg-[#F86900]/10 text-[#B54708] px-4 py-2 w-fit" data-testid="legal-status">{page.status}</p>
          {(page.sections || []).map((s) => (
            <section key={s.heading}><h2 className="font-display font-bold text-xl">{s.heading}</h2><p className="mt-2 text-[#56585E] leading-relaxed">{s.body}</p></section>
          ))}
        </article>
      )}
    </PageShell>
  );
}
